import styled from 'styled-components'
import { Button } from 'reactstrap'

const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Container = styled(Col)``

export const Rule = styled.div`
  background: #e6e6e6;
  height: 1px;
  width: 100%;
  margin: 40px 0;
  @media (max-width: 1360px) {
    height: 1px;
    width: 100%;
    margin: 40px 0;
  }
`

export const AddNewButton = styled(Button)`
  align-self: center;
  width: auto;
`

export const Helper = styled.div`
  display: flex;
  text-align: center;
  color: #a3a3a3;
  margin-bottom: 20px;
`
